import { createContext, useState, useContext, useEffect } from "react";
import { loginUser } from "../interpreter/login";
import { _logout } from "../interpreter/logout";
import { apiRequests } from "../services/api";
import { ME_QUERY } from "../graphql/query/user/query";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchUser();
        const storedUser = localStorage.getItem("user");
    
        if (storedUser) {
            try {
                const parsedUser = JSON.parse(storedUser);
                setUser(parsedUser);
            } catch (error) {
                console.error("Error al parsear usuario de localStorage:", error);
                localStorage.removeItem("user");
            }
        };
    }, []);

    const fetchUser = async () => {
        try {
            setLoading(true);
            //console.log("🔹 Intentando obtener usuario desde el backend...");
    
            const response = await apiRequests(ME_QUERY);
            //console.log("🔹 Respuesta de ME_QUERY:", response);
    
            if (response?.data?.me) {
                if(response.data.me.status === '0'){
                    alert("Tu usuario ha sido dado de baja, pongase en contacto con administracion.");
                    logout(); // función que borra token y redirige a login
                }
                const userData = response.data.me;
                //console.log('234',userData);
                userData.role = Array.isArray(userData.role) ? userData.role : (userData.role ? [{ name: userData.role.name }] : []);
                userData.permissions = Array.isArray(userData.permissions) ? userData.permissions : [];
                //console.log("Usuario obtenido:", userData);
               if (userData.permissions.length === 0) {
                    alert("Tu usuario esta en mantenimiento, espere un momento hasta que este finalizado su proceso.");
                    logout(); // función que borra token y redirige a login
                }
                setUser(userData);
                localStorage.setItem("user", JSON.stringify(userData));
            } else {
                //console.log("No se encontró usuario en ME_QUERY.");
                setUser(null);
                localStorage.removeItem("user");
            }
        } catch (error) {
            //console.error("Error al obtener el usuario:", error);
            setUser(null);
            localStorage.removeItem("user");
        } finally {
            setLoading(false);
        }
    };
    
    const getRedirectPath = (userData) => {
        const roles = userData?.role?.name || "";

        if (roles.includes("Administrativo")) return "/Home";
        if (roles.includes("Soporte")) return "/Control-Tecnico";
        if (roles.includes("Comercial")) return "/Publicidad";
        return "/403"; // Si no hay coincidencia, redirigir a /403
    };

    const login = async (email, password) => {
        try {
            const response = await loginUser(email, password);
            if (response.success) {
                const userData = response;
                setUser(userData);
                localStorage.setItem("user", JSON.stringify(userData));
                localStorage.setItem("token", response.token);
                window.location.href = getRedirectPath(userData);
                return true;
            }
            return response.message || false;
        } catch (error) {
            return error?.message || "Error en el inicio de sesión.";
        }
    };

    const logout = async () => {
        try {
            await _logout();
            setUser(null);
            localStorage.removeItem("user");
            localStorage.removeItem("token");
            window.location.href = "/";
        } catch (error) {
            //console.error("Error en el logout:", error);
            return;
        }
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, fetchUser, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};
